<template>
<div id="login">
    <div class="loginBg"></div>
    <div class="logoImg"></div>
    <div class="loginContent">
      <div class="loginForm">
          <div class="titleuser">
              <img src="../../assets/img/titleuser.png" alt="" />
          </div>
            <i-form ref="formLogin" :model="formLogin" :rules="formLoginRules" class="card-box" autocomplete="on">
              <Form-item prop="username">
                <input class="ivu-input" size="large" type="text" v-model="formLogin.username":placeholder=language.yonghuming>
                <!-- </i-input> -->
                <span class="userIcon"></span>
              </Form-item>
              <Form-item prop="password">
                <input class="ivu-input"  type="password" v-model="formLogin.password" :placeholder=language.mima>
                <!-- </i-input> -->
                <span class="lockIcon"></span>
              </Form-item>
               <!-- <Form-item prop="code"> -->
                 <!-- <input class="ivu-input" size="large" type="text" v-model="formLogin.code" :placeholder=language.yanzhengma style="width:60%;position: relative;left: -50px;"> -->
                 <!-- <span   > -->
                   <!-- {{formLogin.uuid}} -->
                   <!-- <img class="codeImg" :src="'http://10.30.92.154:8094/web/captcha.jpg?uuid='+ formLogin.uuid " @click="getCaptcha()" /> -->
                   <!-- <img class="codeImg" :src="'http://10.157.8.247:7094/web/captcha.jpg?uuid='+ formLogin.uuid " @click="getCaptcha()" /> -->
                   <!-- <img class="codeImg" :src="'http://www.bgmsteelkscm.co.kr:8094/web/captcha.jpg?uuid='+ formLogin.uuid " @click="getCaptcha()" /> -->
                 <!-- </span> -->

              <!-- </Form-item> -->

              <Form-item class="login-no-bottom">
                    <i-button type="primary" @click="handleSubmit('formLogin')">{{language.denglu}}</i-button>
              </Form-item>

            </i-form>
            <button @click="forget" class="wangji">{{language.wangjimima}}</button>
            <!-- <Button @click="modal = true">选择部门</Button> -->
      </div>
      <!-- <Button @click="modal = true">No title bar</Button> -->
      <Modal 
        v-model="modal"
      >
          <!-- <p>Content of dialog</p>
          <p>Content of dialog</p>
          <p>Content of dialog</p> -->
          <Table  border :columns="columns" :data="organization" :highlight-row ="true" ref="selection" @on-row-click="getSelected" ></Table>
          <div slot="footer">
            <Button type="primary"  long  @click="getSelection(selectedCom.segNo)">{{language.queding}}</Button>
        </div>
      </Modal>
      <Modal 
        v-model="modalInfo" width="320px">
          <p style="text-align:center;">选择公司失败，请重新登录</p>
          <div slot="footer" style="text-align:center;">
            <Button type="primary"  long  @click="loginError" style="width:80px;">{{language.queding}}</Button>
        </div>
      </Modal>
    </div>

  </div>

</template>
<script>
  // import language from 'api/language'
  import { getUUID } from '../../util/index'
  // import api from '../../api/apinew'
  import axios from 'axios'
  import Qs from 'qs'
  // import config from 'api/config'
  import config from 'config/apiConfig'
  import language from 'api/language'
  export default {
    data () {
      return {
        modal: false,
        language:{},
        modalInfo:false,
        imgSrc:'',
        pwdword:'',
        email:'',
        formLogin: {
          uuid:'',
          username: '',
          password: '',
          code: '',
          // language:{},
        },
        goIndex:false,

        organization:[ 
           //  {
           //   name:'222',
           //   deptId:'1'
           // },
           // {
           //   name:'222',
           //   deptId:'11'
           // },
        ],
        formLoginRules: {
          username: [
            {required: true, message: '请填写用户名', trigger: 'blur'}
          ],
          password: [
            {required: true, message: '请填写密码', trigger: 'blur'},
            {type: 'string', min: 5, message: '密码长度不能小于6位', trigger: 'blur'}
          ],
          code: [
            {required: true, message: '请填写验证码', trigger: 'blur'}
          ]
        },
        columns:[
            // {
            //     type: 'selection',
            //     width: 60,
            //     align: 'center'
            // },
            {   
                title: '您的组织ID',
                key:'deptId',
                width: 100,
                align: 'center'
            },
            {
                title: '您要登录的组织',
                key: 'name',
                align: 'center'
            }
        ],
        selectedCom:"",
      }
    },
    created:function(){
      this.formLogin.uuid =  getUUID();
    },

    //页面加载调用获取cookie值
    mounted:function(){
       this.remberUser();
       // this.language=language;
    },
    methods: {
      forget(){
        let that= this
        if(that.formLogin.username!=""){

        axios.get(config.rerss,{params: {username:that.formLogin.username}}).then(function(response){
          that.$Message.info(response.data.msg)
          that.pwdword=response.data.pwd
          that.email=response.data.email
          that.forget2()
        })
    }else{
        that.$Message.info(language.qingshurudengluzhanghao)
    }
      },
      forget2(){
        let that= this
        let paramsData={
            emailAddr:that.email,
            context:that.pwdword,
            title:"new Password"


        }
        axios.post(config.sendEmail,paramsData).then(function(response){
            console.log(response.data);
            that.$Message.info(language.xinmimayifasongzhiyouxiang+that.email+language.qingdengluyouxiangchakan)
        })
      },
      remberUser:function(){
           // var username = sessionStorage.getItem('username');
           // var password = sessionStorage.getItem('password')
           // username = username.substring(-1,(username -1));
           // password = password.substring(-1,(password -1));
          if(sessionStorage.getItem('username')){
            this.formLogin.username = sessionStorage.getItem('username');
          }
          if(sessionStorage.getItem('password')){
             this.formLogin.password = sessionStorage.getItem('password');
          }
      },

       //设置cookie
      setCookie(c_name, c_pwd, exdays) {
          debugger;
           var exdate = new Date(); //获取时间
              exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
              //字符串拼接cookie
              window.document.cookie = "username" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
              window.document.cookie = "password" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
        },
      //读取cookie
      getCookie: function() {
          debugger;
          if (document.cookie.length > 0) {
              var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
                for (var i = 0; i < arr.length; i++) {
                        var arr2 = arr[i].split('='); //再次切割
                        //判断查找相对应的值
                        if (arr2[0] == 'username') {
                            this.formLogin.username = arr2[1]; //保存到保存数据的地方
                        } else if (arr2[0] == 'password') {
                            this.formLogin.password = arr2[1];
                        }
                    }
                }
            },
      
      getCaptcha:function(){
        this.formLogin.uuid =  getUUID();
      },
      handleSubmit(name) {
        let that = this;
         // debugger;
        that.$refs[name].validate((valid) => {
          sessionStorage.setItem('user', JSON.stringify(that.formLogin.username));
          if (valid) {
            let paramsData = {
              "username": that.formLogin.username,
              "password": that.formLogin.password,
              "captcha": that.formLogin.code,
              "uuid":that.formLogin.uuid,
            }
            axios.post(config.login,paramsData).then(function(resp){
                if (resp.data.code == 0) {
                  sessionStorage.setItem('token', resp.data.token);
                  sessionStorage.setItem('islogin', true) ;
                  localStorage.setItem('user',JSON.stringify(resp.data.user));
                  axios.get(config.platForm+'/'+resp.data.token,{}).then(function(response){
                  if(!window.localStorage){
                    return false
                  }else{
                    localStorage.setItem("languages",JSON.stringify(response.data.resultData.BGM_SESSION.locale))
                    localStorage.setItem("bsteelUrl",JSON.stringify(response.data.resultData.BGM_SESSION.bsteelUrl))
                    console.log(response.data.resultData.BGM_SESSION.locale+"==="+response.data.resultData.BGM_SESSION.bsteelUrl)
                  }

                  })
                  // 有url,存localStorage
                  if(resp.url !== undefined){
                     localStorage.setItem('URL',JSON.stringify(resp.data.url));
                  }

                  that.organization = [];
                  var object = resp.data.deptList;
                  object.forEach(r=>{
                    if(r.type == 1){
                        that.organization.push(r)
                    }
                  })

                  if(that.organization.length > 1){
                    that.modal = true;
                  }else{
                  // debugger;
                    that.modal = false;
                    that.goIndex = true;
                    that.getSelection(that.organization[0].segNo);
                    // this.getmenuTree(); // 获取menu菜单 
                    // this.$router.push({
                    //   name: 'Index'
                    // })
                  }
                  //保存用户名和密码到cook
                  that.setCookie(that.formLogin.username,that.formLogin.password,9999);
                } else {
                  sessionStorage.setItem('username', that.formLogin.username);

                  sessionStorage.setItem('password', that.formLogin.password);

                  that.$Message.error(language.denglushibai + resp.data.msg)
                }
            })
              .catch(function (error) {
                console.log(error)
            });
          } else {
            this.$Message.error('表单验证失败!');
          }

          // if (this.formLogin.remember[0] == "记住密码") {
          //   sessionStorage.setItem('password', JSON.stringify(this.formLogin.password));
          // } else {
          //   sessionStorage.removeItem('password');
          // }

        })
      },
      loginError:function(){
        this.modalInfo = false;
        location.reload();
      },
      formLoginReset(name){
        this.$refs[name].resetFields();
      },
      getSelected:function(selection){
        this.selectedCom = selection;
      },
      getSelection:function(segNo){
            var token = sessionStorage.getItem("token");
           
            var vue = this;
            let url  = config.loginSys +'?segNo='+segNo
            axios.post(url, {

            },{
              headers: {
                'Accept': 'application/json,text/html,text/html',
                'Content-Type': 'application/json',
                'token': token
              }, 
              transformRequest: [
                function (data) {
                  return Qs.stringify(data);
                }],
            }).then(function (resp) {

                if(vue.goIndex){
                  vue.getmenuTree(); // 获取menu菜单 
                  
                }else{
                  var goUrl = "";
                  if(!localStorage.getItem('URL') === undefined){
                      goUrl = localStorage.getItem('URL');
                  }

                  if(goUrl == '' || goUrl == null){
                      vue.getmenuTree() // 获取menu菜单 
                     
                   }else{
                        location.href = goUrl;
                   }

                }
                 
            }).catch(function (error) {
                console.log(error);
            });
           
            
        },
      guojihua(){
        // this.language = language;

        axios.post(config.getLocale).then(
          function(response){
            localStorage.setItem("languages",JSON.stringify(response.data.resultData.locale))
          })
      },
    
         getmenuTree:function(){
          // 获取menu菜单 
          var token = sessionStorage.getItem("token");
          var vue =  this;
          // let url  = config.sysHeader +'/web/sys/menu/tree'
           axios.get(config.loginMenuTree,{
              headers: {
                'Accept': 'application/json,text/html,text/html',
                'Content-Type': 'application/json',
                'token': token
              }, 
              // transformRequest: [
              //   function (data) {
              //     return Qs.stringify(data);
              //   }],
            }).then(function (resp) {
              localStorage.setItem('menuList',JSON.stringify(resp.data.menuList));

                vue.$router.push({
                      name: 'Index'
                })
            }).catch(function (error) {
                console.log(error);
            });
        },
    },mounted(){
      this.guojihua()
      this.language=language
      this.getCookie();
    }
  }
</script>


<style scoped lang="scss">
  .wangji{
    background-color: black;
    border:none;
    color:#2b85e4;
  }
  #login{
  width:100%;
  overflow:hidden;
  text-align:center;
  .loginBg{
    width:100%;
    max-height:1080px;
    height:100%;
    position: absolute;
    background:url(../../assets/img/bg.jpg) center top no-repeat;
    background-size:1980px 1080px;
  }
  .logoImg{
    width:240px;
    height:61px;
    margin:30px 0 0 50px;
    position: absolute;
    background:url(../../assets/BGMlogo2.png) center top no-repeat;
    background-size:100%;
  }

  .loginContent{
    width:918px;
    height:538px;
    position:absolute;
    left:50%;
    top:50%;
    margin-left:-459px;
    margin-top:-269px;
    background:url(../../assets/img/centerimg.png);

    .loginForm{
      width:260px;
      height:300px;
      position: absolute;
      top:90px;
      right:92px;
      .titleuser{
        height:30px;
        margin-bottom:40px;
      }

      .ivu-form{

        .ivu-form-item{
            margin-bottom:22px;
            .ivu-btn {
              width: 100%;
              margin-top:20px;
              font-size:18px;
              height:40px;
            }
            .ivu-form-item-content{
              position:relative;
              .ivu-input{
                  font-size:14px;
                  height:40px;
                  color:#fff !important;
                  background-color: rgba(0,0,0,0.1) !important;
              }
              .userIcon,.lockIcon{
                  width:15px;
                  height:15px;
                  background-size:100%;
                  position:absolute;
                  top:12px;
                  right:8px;
              }
              .userIcon{
                 background:url(../../assets/img/iconuser.png) no-repeat;
              }
              .lockIcon{
                  background:url(../../assets/img/iconlock.png) no-repeat;

              }
              .codeImg{
                display:inline-block;
                cursor:pointer;
                position:absolute;
                top:0;
                right:0;
                width:35%;
                height:40px;
                border-radius:5px;
              }
            }


        }

      }

    }
  }


}

</style>



// WEBPACK FOOTER //
// index.vue?d540a25a